import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-heading-page-ui',
    template: '',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbHeadingPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
